const KNOWN_OFFICIAL_METRICS_ERRORS = new Set([
  'instagram_insights_permission_denied',
  'instagram_media_unavailable',
  'facebook_insights_permission_denied',
  'facebook_media_unavailable',
  'social_connection_reconnect_required',
  'unofficial_metrics_source',
  'official_media_identity_mismatch',
  'official_metrics_failed',
]);

export function mapOfficialMetricsError(raw: string | null | undefined): string | null {
  if (raw == null || !String(raw).trim()) return null;
  const value = String(raw).trim();
  const code = KNOWN_OFFICIAL_METRICS_ERRORS.has(value) ? value : 'official_metrics_failed';
  return `campaign.submissions.metricsErrors.${code}`;
}
